export { default } from "./CommonTable";
